import ACFilterTypes from "../modules/filter-types";
import Date from "./date";
import Integer from "./integer";
import Double from "./double";
import Select from "./select";
import Ajax from "./ajax";
import Select2Preload from "./select2_preload";
export var getConfiguredFilterTypes = function () {
    var filterTypes = new ACFilterTypes();
    filterTypes.addType(new Integer());
    filterTypes.addType(new Double());
    filterTypes.addType(new Ajax());
    filterTypes.addType(new Select());
    filterTypes.addType(new Select2Preload());
    filterTypes.addType(new Date);
    return filterTypes;
};
